import { Card, CardBody, CardTitle, Col, Container, Button, Row, Form, CardFooter } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import '../Css/Contact.css';
import Loader from "../component/Loader";
import aman from '../image/New Stud Dash/aman.webp';
import { FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Autoplay, FreeMode } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import scp1 from '../image/New Stud Dash/online (1).webp';
import group from '../image/New Stud Dash/2.webp';
import Career from '../image/New Stud Dash/3.webp'
import line from '../image/New Stud Dash/pricing-line-red.webp';
import rounded from '../image/New Stud Dash/rounded.webp';
import student from '../image/New Stud Dash/student.webp';
import school from '../image/New Stud Dash/schoolwebp.webp';
import management from '../image/New Stud Dash/management.webp';
import dashboard from '../image/New Stud Dash/dashboard.webp';
import webinar from '../image/New Stud Dash/webinar.webp';
import chat from '../image/New Stud Dash/chat.webp';
import sucess from '../image/New Stud Dash/elevate-student-success.svg';
import Strengthen from '../image/New Stud Dash/strengthen-alumni-impact.svg';
import Enhance from '../image/New Stud Dash/enhance-institution-reputation.svg';
import Support from '../image/New Stud Dash/support-for-placement-teams.svg';
import sv from "../image/New Stud Dash/sv.webp";
import Features from "../component/Feature";
const workshopData = [
    { title: "Balanand Vidhyalay" },
    { title: "Harekrushna Vidhyalaya" },
    { title: "Nilmadhav Vidhyalaya" },
    { title: "Surat Diamond Girls Association School" },
    { title: "Gadhpur Vidhyalay" },
    { title: "Gyandeep Vidhyalaya" },
    { title: "Gyanganga Global School" },
    { title: "Bhagwati Vidhyalaya" },
    { title: "Nilkanth Kanya Vidhyalaya" },
];
// show image dynamicly
function importAll(r) {
    let images = {};
    r.keys().forEach((item) => {
        const name = item.replace("./", "").split(".")[0]
        images[name] = r(item);
    });
    return images;
}
const images = importAll(require.context("../image/image/", true, /\.(webp)$/));
function School() {
    // form
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        category: "",
        city: "",
        message: "",
    });
    const Showerror = (msg) => {
        toast.error(msg, {
            position: "top-right",
            className: "toast-responsive mx-3",
        });
    };
    //custom sucessfully message handle
    const Showsucess = (msg) => {
        toast.success(msg, {
            position: "top-right",
            className: "toast-responsive mx-3",
        });
    };
    // Handle Input Change
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
            if (value.length > 10) return;
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    // Handle Form Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_ENDPOINT}/contact`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            Showsucess(response?.data?.message);
            setFormData({
                name: "",
                email: "",
                phone: "",
                category: "",
                city: "",
                message: "",
            });
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                Showerror(error.response.data.error);
            } else {
                Showerror("Something went wrong! Please try again.");
            }
        }
    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState({ title: "", images: [], image: "" });
    const [imageCounts, setImageCounts] = useState({});
    const [loadedImages, setLoadedImages] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (images) {
            setLoadedImages(images);
            setLoading(false);
        }
    }, []);
    const swiperRef = useRef(null);
    useEffect(() => {
        if (swiperRef.current) {
            setTimeout(() => {
                swiperRef.current.swiper.autoplay.start();
            }, 500);
        }
    }, [loading]);
    // video
    const [videoboxOpen, setVideoboxOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(0);
    const openVideo = (videoUrl) => {
        const autoplayUrl = videoUrl.split("?")[0] + "?autoplay=1";
        setCurrentVideo(autoplayUrl);
        setVideoboxOpen(true);
    }
    // Open Modal with dynamic content
    const openModal = (workshop) => {
        const folderName = (workshop.title);
        setModalData({ title: workshop.title, images: imageCounts[folderName] || [] });;
        setModalOpen(true);
    };
    // image show
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [conatctboxOpen, setConatctboxOpen] = useState(false);
    // Open Lightbox with Clicked Image
    const openLightbox = (index) => {
        setModalOpen(false);
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    // Next Image Function
    const nextImage = () => {
        setCurrentIndex((prevIndex) => {
            let newIndex = prevIndex === modalData.images.length - 1 ? 0 : prevIndex + 1;
            return newIndex;
        });
    };
    const prevImage = () => {
        setCurrentIndex((prevIndex) => {
            let newIndex = prevIndex === 0 ? modalData.images.length - 1 : prevIndex - 1;
            return newIndex;
        });
    };
    return (
        <>
            {loading && <Loader showimg={loading} />}
            <Container fluid className="herosec_gallery py-sm-5 overflow-hidden">
                <Container>
                    <Row className="mt-sm-4  mb-sm-0 text-center">
                        <h1 style={{ letterSpacing: "0.8px" }} className="text-center fw-semibold text-white">Empower Your Students to Build Successful Careers with CareerSahi</h1>
                        <h6 style={{ letterSpacing: "0.8px" }} className="text-center desc_header text-white">Comprehensive Career Guidance Solutions for Schools and Colleges</h6>
                        <div>
                            <Link onClick={() => setConatctboxOpen(true)} style={{ background: "var(--primary-color)" }} class="btn custome_button border-0 text-white py-3 px-5 mt-3" >Connect with us</Link></div>
                    </Row>
                </Container>
            </Container>
            {/* <Container fluid>
                <Row className="justify-content-center pt-4">
                    <Col md="11" xxl="9">
                        <Row className="g-4 justify-content-center pt-5">
                            {workshopData.map((workshop, index) => {
                                const folderName = (workshop.title);
                                const images = imageCounts[folderName] || [];
                                return (
                                    <Col sm="6" md="4" xl="3" className="pointer h-auto" key={index}>
                                        <Card className="h-100" onClick={() => openModal(workshop)}>
                                            {images.length > 0 && (
                                                <img
                                                    src={images[0]}
                                                    alt={workshop.title}
                                                    className="object-cover"
                                                    onError={(e) => (e.target.style.display = "none")}
                                                />
                                            )}
                                            <CardBody style={{ background: "rgb(11, 96, 177)" }} className="text-center align-items-center d-flex justify-content-center custome_button p-2 h-100">
                                                <CardTitle style={{ fontSize: "16px" }} className="text-white">{workshop.title}</CardTitle>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                )
                            })}
                        </Row>
                    </Col>
                </Row>
            </Container> */}
            {/* Single Modal for All Cards */}
            {/* <Modal style={{ zIndex: "100000" }} size="lg" show={modalOpen} onHide={() => setModalOpen(false)}>
                <ModalHeader style={{ position: "sticky", top: "0px", backgroundColor: "white", zIndex: 1050 }} className="fw-semibold mx-3  fs-5" toggle={() => setModalOpen(false)} closeButton>{modalData.title}</ModalHeader>
                <ModalBody className="text-center mx-3">
                    <Row>
                        {modalData?.images.map((image, index) => (
                            <Col sm="6" lg="4" key={index} className="mb-3">
                                <img style={{ objectFit: "cover" }} src={image} alt={`workshop_img_${index}`} className="h-100 w-100 pointer" onClick={() => openLightbox(index)} />
                            </Col>
                        ))}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button className="text-muted fw-semibold fs-5 text-end border-0" style={{ background: 'none' }} onClick={() => setModalOpen(false)}>Back</Button>
                </ModalFooter>
            </Modal> */}
            {/* <!-- lightboxer with Slider --> */}
            {/* {lightboxOpen && (
                <>
                    <div className="lightboxer" onClick={(e) => {
                        if (e.target.classList.contains("lightboxer")) {
                            setLightboxOpen(false);
                            setModalOpen(true);
                        }
                    }}>
                        <span className="close-lightboxer" onClick={() => setLightboxOpen(false)}>×</span>
                        <img src={modalData.images[currentIndex] || ""} alt="lightboxerImage" />
                        <button className="prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>❮</button>
                        <button className="next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>❯</button>
                    </div>
                </>
            )} */}
            {/* school sider */}
            <Swiper
                slidesPerView={5}
                ref={swiperRef}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                }}
                speed={6000}
                freeModeMomentumRatio={0}
                modules={[Autoplay, FreeMode]}
                breakpoints={{
                    320: { slidesPerView: 1.2, spaceBetween: 20 },
                    380: { slidesPerView: 1.5, spaceBetween: 20 },
                    450: { slidesPerView: 2, spaceBetween: 20 },
                    576: { slidesPerView: 2, spaceBetween: 20 },
                    768: { slidesPerView: 3, spaceBetween: 20 },
                    1000: { slidesPerView: 3.2, spaceBetween: 20 },
                    1300: { slidesPerView: 5, spaceBetween: 20 },
                }}
            > {workshopData.map((workshop, index) => {
                const baseTitle = workshop.title.trim();
                const matchingKeys = loadedImages
                    ? Object.keys(loadedImages).filter(key => key.startsWith(baseTitle))
                    : [];
                let imageSrc = null;
                if (matchingKeys.length > 0) {
                    imageSrc = images[matchingKeys[0]];
                }
                // Construct dynamic path for logo image
                const logoPath = require(`../image/image/${baseTitle}/logo.webp`);
                return (
                    <SwiperSlide key={index} className="h-auto">
                        <Card className="h-100">
                            <CardBody className="p-0">
                                <LazyLoadImage
                                    src={imageSrc}
                                    alt={workshop.title}
                                    className="school_image rounded-1"
                                    onError={(e) => (e.target.style.display = "none")}
                                />
                            </CardBody>
                            <CardFooter 
                            style={{background:"none"}}
                                // style={{ background: "rgb(247, 247, 247)" }}
                                className="align-items-center d-flex justify-content-center rounded-1  h-100"
                            >
                                <LazyLoadImage height={50} src={logoPath} alt="logo" />
                                <CardTitle  className="ps-3 pt-1 school_text fw-semibold align-self-center">
                                    {workshop?.title}
                                </CardTitle>
                            </CardFooter>
                        </Card>
                    </SwiperSlide>
                )
            })}
            </Swiper>
            {/* Benefits for Schools and Colleges */}
            {/* <Container className="benifit_sections">
                <Row className="pt-5 mt-4">
                    <Col>
                        <div className="section-title-1 position-relative pb-2 mb-4">
                            <div className="fw-bold heading_home">Benefits for Schools and Colleges</div>
                        </div>
                        <p className="text-muted mb-5">Educational institutions, including schools, colleges, and universities, can significantly enhance their students by supporting them to create a clear roadmap for career development. By incorporating structured career guidance into their programs, these institutions empower students to make informed decisions and pursue fulfilling paths. Here are the key benefits for schools and colleges:</p>
                    </Col>
                    <Row>
                        <Col>
                            <div className="cards mb-5">
                                <div className="stacking-card is--first col-lg-12">
                                    <div className="card">
                                        <div className="card_inner">
                                            <div className="row">
                                                <div class="col-sm-4 d-flex justify-content-center">
                                                    <div class="card__image-container">
                                                        <img src={sucess} className="card__image" alt="TrainingImage" />
                                                    </div>
                                                </div>
                                                <div class="col-sm-8 d-flex">
                                                    <div class="card__content">
                                                        <h3 class="card-heading1 fw-bold">Elevate Student Success</h3>
                                                        <p className="card_desc">Help students make informed career choices early on, leading to higher satisfaction and academic performance.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="stacking-card is--second col-lg-12">
                                    <div className="card">
                                        <div className="card_inner1">
                                            <div className="row">
                                                <div class="col-sm-8 d-flex">
                                                    <div class="card__content">
                                                        <h3 class="card-heading1 fw-bold">Strengthen Alumni Impact</h3>
                                                        <p className="card_desc">Produce successful graduates who become leaders and experts in their fields.</p>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4 d-flex justify-content-center">
                                                    <div class="card__image-container">
                                                        <img src={Strengthen} className="card__image" alt="TrainingImage" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="stacking-card is--third col-lg-12">
                                    <div className="card">
                                        <div className="card_inner">
                                            <div className="row">
                                                <div class="col-sm-4 d-flex justify-content-center">
                                                    <div class="card__image-container">
                                                        <img src={Enhance} className="card__image" alt="TrainingImage" />
                                                    </div>
                                                </div>
                                                <div class="col-sm-8 d-flex">
                                                    <div class="card__content">
                                                        <h3 class="card-heading1 fw-bold">Enhance Institution Reputation</h3>
                                                        <p className="card_desc">Enhance your student development programs by integrating career guidance for college students to help them succeed.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="stacking-card is--fourth col-lg-12">
                                    <div className="card">
                                        <div className="card_inner1">
                                            <div className="row">
                                                <div class="col-sm-8 d-flex">
                                                    <div class="card__content">
                                                        <h3 class="card-heading1 fw-bold">Support for Placement Teams</h3>
                                                        <p className="card_desc">Our services complement placement activities by aligning students with careers they are passionate about.</p>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4 d-flex justify-content-center">
                                                    <div class="card__image-container">
                                                        <img src={Support} className="card__image" alt="TrainingImage" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Row>
            </Container> */}
            {/* card fectures */}
            <Features />
            {/* HOW IT WORKS? 3-Step Approach for Student Success */}
            <Container fluid className="mb-5 ">
                <div className="container mt-5">
                    <div class=" text-center position-relative pb-3 mb-2 mx-auto">
                        <h5 className="heading1">
                            HOW IT WORKS?
                        </h5>
                        <div className="d-flex justify-content-center align-items-center"><img width={100} alt="line" src={line} /></div>
                        <h2 className="mb-0 fw-bold heading_home">3-Step Approach for Student Success</h2>
                    </div>
                    <Row>
                        <div class="col-lg-4 col-md-6 process-item wow" >
                            <div class="position-relative d-flex flex-column align-items-center text-center">
                                <img class="image-how" src={scp1} alt="tests" />
                                <p>Step - 1</p>
                                <div class="work-process-icon">
                                    <h5> <strong className="fw-bold">Online Assessments</strong></h5>
                                </div>
                                <div class="d-flex justify-content-center align-items-center"><img width={100} alt="line" src={line} /></div>
                                <span className="text-muted desc_header">Students take assessments online, anytime and anywhere—at home, school labs, or personal laptops. Comprehensive reports are automatically generated, offering personalized insights.</span>
                                <br />
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 process-item wow" >
                            <div class="position-relative d-flex flex-column align-items-center text-center">
                                <img class="image-how" src={group} alt="tests" />
                                <p>Step - 2</p>
                                <div class="work-process-icon">
                                    <h5> <strong className="fw-bold">Group Counselling</strong></h5>
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <img width={100} alt="line" src={line} />
                                </div>
                                <span className="text-muted desc_header">Conducted by expert career counsellors to promote self-awareness and peer learning. This session allows students to explore various career options collectively, fostering a broader understanding through interactive discussions.</span>
                                <br />
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 process-item wow" >
                            <div class="d-flex flex-column align-items-center text-center">
                                <img class="image-how" src={Career} alt="tests" />
                                <p>Step - 3</p>
                                <div class="work-process-icon">
                                    <h5> <strong className="fw-bold">One-on-One Career Guidance with Parents </strong></h5>
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <img width={100} alt="line" src={line} />
                                </div>
                                <span className="text-muted desc_header">Individual sessions with students and parents to discuss recommended career paths. Counsellors guide parents on the best career options, explaining how each aligns with the student’s strengths and interests.                                </span>
                                <br />
                            </div>
                        </div>
                    </Row>
                </div>
            </Container>
            {/* Turning point  */}
            {/* <Container className="mt-5 turning_point pt-5">
                <div className="text-center mb-5">
                    <h2 className="fw-semibold">At Turning point, We help pupils, College graduates and working professionals.</h2>
                    <p style={{ fontSize: "17px" }} className="text-muted pt-1 fw-semibold">Turning Point Counselling Services are rated as the best career counselling in Hyderabad and across the Cities.</p>
                </div>
                <Row className="border mx-sm-0 mx-1">
                    <Col md="3" className="border-end">
                        <div className="pt-4 pb-3 text-center">
                            <img height={160} alt="image8_10" src={image8_10} />
                            <h4 className="fw-semibold">8th - 10th</h4>
                            <p className="text-muted">Stream & Subject Selection</p>
                        </div>
                    </Col>
                    <Col md="3" className="border-end">
                        <div className="pt-4 pb-3 text-center">
                            <img height={160} alt="image8_10" src={image11_12} />
                            <h4 className="fw-semibold">11th - 12th</h4>
                            <p className="text-muted">Planning & Career Selection</p>
                        </div>
                    </Col>
                    <Col md="3" className="border-end">
                        <div className="pt-4 pb-3 text-center">
                            <img height={160} alt="image8_10" src={college} />
                            <h4 className="fw-semibold">College Graduates</h4>
                            <p className="text-muted">Career Selection & Development</p>
                        </div>
                    </Col>
                    <Col md="3" className="">
                        <div className="pt-4 pb-3 text-center">
                            <img height={160} alt="image8_10" src={working} />
                            <h4 className="fw-semibold">Working Professionals</h4>
                            <p className="text-muted">Planning & Career Selection</p>
                        </div>
                    </Col>
                </Row>
            </Container> */}
            {/* partener */}
            <Container fluid className="about_us pb-4">
                <Row className="justify-content-center">
                    <Col xs="12 text-center">
                        <div className="heading_home  pt-3 pb-5 fw-bold">Why Partner with Us?</div>
                    </Col>
                    <Col lg="11" md="10" xl="10">
                        <Row className="d-flex justify-content-center align-items-center">
                            <Col xl="5" lg="6" className="justify-content-center h-100 d-flex mb-lg-0 mb-3">
                                <div className="SV text-center">
                                    <img className="col-xl-12 col-lg-12 col-md-8 col-sm-10 col-12 rounded-3"
                                        src={sv}
                                        autoplay="1"
                                        alt="Click to play video"
                                        onClick={() => openVideo("https://www.youtube.com/embed/WiuUMQI2vY4")}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                            </Col>
                            <Col md="8" sm="10" xs="12" lg="6" className="align-self-center h-100  mx-auto">
                                <div className="">
                                    <ul className="p-0 m-0" style={{ listStyle: 'none' }}>
                                        <li><div style={{ fontSize: '22px', textTransform: 'capitalize', lineHeight: '50px' }}>ભારતનું આધુનિક <span className="fw-semibold" style={{ color: "var(--primary-color)" }}>સચોટ અને નીસ્પક્ષ </span> કરિયર પ્લાનિંગ કરાવતું પ્લેટફોર્મ.</div></li>
                                        <li><div style={{ fontSize: '22px', textTransform: 'capitalize', lineHeight: '50px' }}>735 દિવસોનું રિસર્ચ અને <span className="fw-semibold" style={{ color: "var(--primary-color)" }}>250+ ઇન્ડસ્ટ્રી એક્સપર્ટસના</span> સર્વે પછી તૈયાર થયેલું પ્લેટફોર્મ.</div></li>
                                        <li><div style={{ fontSize: '22px', textTransform: 'capitalize', lineHeight: '50px' }}>અમેરિકા, ફિનલેન્ડ, અને જાપાન જેવા 10થી વધુ<span className="fw-semibold" style={{ color: "var(--primary-color)" }}> વિકસિત દેશોની એજ્યુકેશન સિસ્ટમ</span> સાથે તૈયાર કરાયેલ એકમાત્ર પ્લેટફોર્મ.</div></li>
                                        <li><div style={{ fontSize: '22px', textTransform: 'capitalize', lineHeight: '50px' }}> <span className="fw-semibold" style={{ color: "var(--primary-color)" }}> કરિયર ગાઈડન્સ, મેન્ટોરશીપ, જોબ અને બિઝનેસની તકો</span> જેવા 35+ પેરામીટર તપાસીને સચોટ કરિયર માર્ગદર્શન આપતું એકમાત્ર પ્લેટફોર્મ.</div></li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            {/* pop up */}
            {videoboxOpen && (
                <>
                    <div className="lightboxx">
                        <div className="video-container">
                            <span className="close-lightboxer" onClick={() => setVideoboxOpen(false)}>×</span>
                            <iframe key={currentVideo}
                                src={currentVideo}
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </>
            )}
            {/* Technology-Led Career Guidance */}
            {/* <Container fluid className="mt-5" style={{
                backgroundColor: "transparent",
                backgroundImage: "linear-gradient(180deg, #EEF6FF 0%, #EEF6FF00 100%)"
            }}>
                <Container className="py-4 mt-5">
                    <div className="text-center">
                        <div className="heading_home fw-bold">Technology-Led Career Guidance</div>
                        <p style={{ fontSize: "17px" }} className="text-muted fw-semibold">Leveraging technology to empower all stakeholders: Students, Parents, Schools, Counsellors.</p>
                    </div>
                    <Row className="pt-4 d-flex justify-content-center">
                        <Col md="4" xl={3} className="align-self-center">
                            <div className="d-flex">
                                <img height={35} alt="rounded" src={rounded} />
                                <p className="fs-5 ps-4">Dashboard for :</p>
                            </div>
                        </Col>
                        <Col md="8" xl="7">
                            <Row className="g-5">
                                <Col className="p-0" xs="4" sm="4" lg="3">
                                    <img className="col-12" alt="student" src={student} />
                                </Col>
                                <Col className="p-0 ms-lg-4" xs="4" sm="4" lg="3">
                                    <img className="col-12" alt="school" src={school} />
                                </Col>
                                <Col className="p-0 ms-lg-4" xs="4" sm="4" lg="3">
                                    <img className="col-12" alt="management" src={management} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="pt-5 mt-xl  -3 d-flex justify-content-center">
                        <Col md="4" xl={3} className="align-self-center">
                            <div className="d-flex">
                                <img height={35} alt="rounded" src={rounded} />
                                <p className="fs-5 ps-4">Additional Features :</p>
                            </div>
                        </Col>
                        <Col md="8" xl="7">
                            <Row className="g-5">
                                <Col className="p-0" xs="4" sm="4" lg="3">
                                    <img className="col-12" alt="student" src={dashboard} />
                                </Col>
                                <Col className="p-0 ms-lg-4" xs="4" sm="4" lg="3">
                                    <img className="col-12" alt="student" src={webinar} />
                                </Col>
                                <Col className="p-0 ms-lg-4" xs="4" sm="4" lg="3">
                                    <img className="col-12" alt="student" src={chat} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className="text-center">
                        <Button style={{ background: 'var(--primary-color)' }} onClick={() => setConatctboxOpen(true)} className="text-white custome_button px-4 mt-5">Get in Touch</Button>
                    </div>
                </Container>
            </Container>  */}
            {/* contact */}
            <div className="counseller_contact mt-5 pt-sm-5">
                <Container fluid style={{ background: "#1E2538"}}>
                    <Row className="justify-content-center">
                        <Col lg="11" xl="10" xxl="7" className="py-5">
                            <div className="py-sm-5 py-3 justify-content-center  d-flex flex-md-nowrap flex-wrap align-items-center justify-content-sm-between">
                                <div className="d-flex flex-sm-nowrap justify-content-center text-center text-sm-start flex-wrap">
                                    <div className="text-center justify-content-center  col-sm col-12">
                                        <img src={aman} alt="meena" className="align-self-center counsellor_image rounded-circle" />
                                    </div>
                                    <div className="text-white ps-sm-5">
                                        <div className="fs-4 fw-bold counseling_title">Aman Ajudiya</div>
                                        <div className="fs-4 counseling_desc py-sm-2">Director, School Partnerships Programs</div>
                                        <div className="fs-4  pointer"><Link className="counseling_desc text-white" to={"tel:+91-96620-87470"}>+91-96620-87470</Link></div>
                                        <div className="py-sm-2 fs-4"><Link to="mailto:aman.ajudiya@careersahi.com" className="text-decoration-none counseling_desc pointer text-white">
                                            aman.ajudiya@careersahi.com
                                        </Link></div>
                                    </div>
                                </div>
                                <div className="text-center mt-sm-0 mt-2 ms-md-0 ms-sm-auto me-sm-3">
                                    <div className="fs-4 text-white fw-bold">Contact Us</div>
                                    <Link target="_blank" to="https://api.whatsapp.com/send/?phone=9662087470&text=Hello CareerSahi&type=phone_number&app_absent=0">
                                        <button  className="px-md-4 px-3 mt-sm-3 mt-1 fs-5 d-flex align-items-center rounded-1 whats_button border-0 py-2 text-white">
                                            <FaWhatsapp className="fs-5 mt-1 align-self-center me-2 " />
                                          Chat on WhatsApp
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                        <button style={{ height: "18px" }} className="bg-white col-12 mb-2 border-0"></button>
                    </Row>
                </Container>
            </div>
            {/* contact with us form  */}
            {conatctboxOpen && (
                <div id="lightboxx" className="lightbox-overlay">
                    <div className="lightbox-content">
                        <section id="lightboxSection">
                            <div style={{ borderRadius: "8px" }} className="col-lg-12 bg-white m-auto p-4">
                                <span className="lightbox-close pointer" onClick={() => setConatctboxOpen(false)} style={{ margin: "10px" }}>×</span>
                                <div className="text-center" style={{ maxWidth: "420px", margin: 'auto' }}>
                                    <h5 className="Get_Touch text-black pt-3 fw-semibold pb-4 text-center">
                                        Get in Touch With Our Career Experts!
                                    </h5>
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Full Name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            autoComplete="off"
                                            required
                                            className="input my-2"
                                        />
                                        <Row>
                                            <Col lg={6}>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Email"
                                                    name="email"
                                                    autoComplete="off"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                    className="input my-2"
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <Form.Control
                                                    type="tel"
                                                    name="phone"
                                                    autoComplete="off"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="Phone"
                                                    className="input my-2"
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6}>
                                                <Form.Select
                                                    name="category"
                                                    value={formData.category}
                                                    onChange={handleChange}
                                                    required
                                                    className="input my-2"
                                                >
                                                    <option value="" disabled selected>
                                                        -Select-
                                                    </option>
                                                    <option value="Student (8-10 Std)">
                                                        Student (8-10 Std)
                                                    </option>
                                                    <option value="Student (11-12 Std)">
                                                        Student (11-12 Std)
                                                    </option>
                                                    <option value="Student (UG)">Student (UG)</option>
                                                    <option value="Student (PG)">Student (PG)</option>
                                                    <option value="Parent (8-10 Std)">Parent (8-10 Std)</option>
                                                    <option value="Parent (11-12 Std)">
                                                        Parent (11-12 Std)
                                                    </option>
                                                    <option value="Parent (UG)">Parent (UG)</option>
                                                    <option value="Parent (PG)">Parent (PG)</option>
                                                    <option value="Working Professional (1-10 yrs exp)">
                                                        Working Professional (1-10 yrs exp)
                                                    </option>
                                                    <option value="Senior Working Professional (10+ yrs exp)">
                                                        Senior Working Professional (10+ yrs exp)
                                                    </option>
                                                    <option value="Executive with Career Break">
                                                        Executive with Career Break
                                                    </option>
                                                    <option value="Principal/Teacher">Principal/Teacher</option>
                                                    <option value="Others">Others</option>
                                                </Form.Select>
                                            </Col>
                                            <Col lg={6}>
                                                <Form.Control
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder="City"
                                                    name="city"
                                                    value={formData.city}
                                                    onChange={handleChange}
                                                    className="input my-2"
                                                />
                                            </Col>
                                        </Row>
                                        <Form.Control
                                            as="textarea"
                                            placeholder="Anything We Need To Know? (Optional)"
                                            className="input mt-2 mb-3"
                                            name="message"
                                            autoComplete="off"
                                            style={{ height: '100px' }}
                                            value={formData.message}
                                            onChange={handleChange}
                                        />
                                        <div className="text-center">
                                            <Button type="submit" className="submit_btn border-0 custome_button px-5 py-2">
                                                Submit
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            )}
        </>
    )
}
export default School